// extracted by mini-css-extract-plugin
export default {"h3":"Populars_h3__SAO4a"};